import React, { useEffect, useMemo, useState } from "react";
import { getCategory } from "../../Services/CategoryApi";
import Select from "react-tailwindcss-select";
import { useTerminalConfig } from "../../Path/NewTerminalConfigs";
import { isNil, uniq } from "lodash-es";
import CreateCategory from "./CreateCategory";
import CategoryEditRequest from "./CategoryEditRequest";
import { useTranslation } from "react-i18next";
import { getTerminalCategoryScraper } from "../../Services/terminal";

const CategoryScraperForm = () => {
    const { terminalConfig, setTerminalConfig } = useTerminalConfig();
    const [categories, setCategories] = useState();
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const fetchCategories = async () => {
        try {
            const response = await getCategory();
            const apiData = response.data.data;
            setCategories(apiData);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };
    const fetchTerminalCategoryScraper = async () => {
        if (terminalConfig?.cityId) {
            try {
                const res = await getTerminalCategoryScraper(terminalConfig.cityId);
                const scrapers = res.data.data || [];

                setTerminalConfig(prev => ({
                    ...prev,
                    scrapers: scrapers.map(scr => ({
                        ...scr,
                        isValidScrapper: true,
                        link: scr.link || ''
                    }))
                }));
            } catch (scraperErr) {
                console.error("Error fetching scrapers:", scraperErr);
            }
        }
    };
    useEffect(() => {
        fetchCategories();
        fetchTerminalCategoryScraper();
    }, [terminalConfig?.cityId]);

    useEffect(() => {
        if (terminalConfig.categoryIds.length) {
            const SS = categories?.filter((s) => terminalConfig?.categoryIds?.includes(s.id));
            setTerminalConfig((prev) => ({ ...prev, selectedCategoriesIds: SS ?? [], }))
        }
    }, [categories, terminalConfig.categoryIds]);

    const onRemoveCtegory = (id) => {
        setTerminalConfig((prev) => ({ ...prev, selectedCategoriesIds: prev?.selectedCategoriesIds.filter((ser) => ser.id !== id) }))
    }

  const selectOptions = useMemo(() => {
        if (!categories) return [];
        return categories
            .filter((s) => !terminalConfig?.selectedCategoriesIds?.find((ser) => ser.id === s.id))
            .map((cities) => ({ value: cities.id, label: cities.name, ...cities }));
    }, [categories, terminalConfig?.selectedCategoriesIds]);  
    
 

    return (
        <div className="mt-6">
            <h2 className="text-2xl font-bold mb-4 text-white">{t("CategoryScraperSetup")}</h2>
            <CategoryEditRequest cityId={terminalConfig?.cityId} selectedCategoriesIds={terminalConfig.selectedCategoriesIds} deleteCategories={onRemoveCtegory} scrapers={terminalConfig?.scrapers}
                close={(refetchCategories) => {
                    setShowModal(false)
                    if (refetchCategories) {
                        fetchCategories();
                        fetchTerminalCategoryScraper();
                    }
                }
                }
            />
            <form class="max-w-sm">
                <label for="countries" class="block mb-2 text-sm font-medium text-white">{t("SelectCategory")}</label>
                <Select
                    primaryColor="indigo"
                    placeholder={t("SelectCategory")}
                    onChange={(val) => {
                        if (isNil(terminalConfig.selectedCategoriesIds) || terminalConfig.selectedCategoriesIds?.length < 3) {
                            setTerminalConfig((prev) => ({ ...prev, selectedCategoriesIds: (uniq([...prev.selectedCategoriesIds, val])) ?? [] }))
                        }
                    }}
                    options={selectOptions}
                    // options={categories?.filter((s) => !terminalConfig?.selectedCategoriesIds.find((ser) => ser.id === s.id)).map((cities) => ({ value: cities.id, label: cities.name, ...cities }))}
                />
            </form>
            {terminalConfig.selectedCategoriesIds?.length >= 3 && <p className="text-md text-red-400">{t("maximum_limit")}</p>}
            <button
                onClick={() => setShowModal(true)}
                className="text-sm text-primary hover:underline mt-2 bg-blue-600 py-2 px-4 rounded font-semibold text-white"
            >
                {t("category_button")}
            </button>
            {/* Modal */}
            {showModal && (
                <CreateCategory
                    cityId={terminalConfig?.cityId}
                    scrapers={terminalConfig?.scrapers}
                    isOpen={showModal} close={(refetchCategories) => {
                        setShowModal(false)
                        if (refetchCategories) {
                            fetchCategories();
                            fetchTerminalCategoryScraper();
                        }
                    }
                    } />
            )}
        </div>
    );
}

export default CategoryScraperForm;
